export default __webpack_public_path__ + "static/media/catalog_point_img02.73aee8f8.svg";